import { useRef, useState, memo } from 'react';
import './Column.scss';
import sortByKeyOfAnotherArr from 'utilities/sortByKeyOfAnotherArr';

import Card from '../Card/Card';

import { Droppable } from 'react-beautiful-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

function Column({ column, handleShowPopOver, handleUpdateCloumnTitle }) {
  const { cards, cardOrder } = column;
  const [titleValue, setTitleValue] = useState(column.title);
  const titleRef = useRef();
  const headerOption = useRef();

  const sortedCards = sortByKeyOfAnotherArr(cards, cardOrder, 'id');

  // handle edit column title
  const handleEditTitle = () => {
    titleRef.current.select();
    console.log('edit');
  };
  const handleOnInputTitle = (e) => {
    setTitleValue(e.target.value);
  };
  const handleOnKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };

  return (
    <div className='column'>
      <div className='column_pin'>
        <FontAwesomeIcon icon={solid('paperclip')} />
      </div>
      <header>
        <textarea
          ref={titleRef}
          onInput={handleOnInputTitle}
          onKeyDown={handleOnKeyDown}
          spellCheck='false'
          value={titleValue}
          onBlur={() => {
            handleUpdateCloumnTitle(titleValue, column.id);
          }}
          className='header_title'
        ></textarea>
        <div
          ref={headerOption}
          onClick={() => handleShowPopOver(headerOption)}
          className='header_options'
        >
          <FontAwesomeIcon icon={solid('ellipsis')} />
        </div>
        <div
          onClick={handleEditTitle}
          className='header_cover_edit_target'
        ></div>
      </header>
      <Droppable droppableId={column.id}>
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className='card_list'
          >
            {sortedCards.map((card, index) => (
              <Card key={card.id} card={card} index={index} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      <footer>
        <div className='footer_add'>
          <FontAwesomeIcon icon={solid('plus')} />
          Add a card
        </div>
      </footer>
    </div>
  );
}

export default memo(Column);
